(function () {
    'use strict';

    /**
     * @ngdoc object
     * 
     *
     * @description
     *
     */
    angular
        .module('missingSignIn')
        .controller('reportActivationCtrl', reportActivationCtrl);

    function reportActivationCtrl($uibModalInstance, modalParams, MissingSignInService, MessageService,EventManagerService) {
        var vm = this;
        vm.ctrlName = 'reportActivationCtrl';
        
        vm.model = {
        	activationData: {
            	crewScheduleBlockId : modalParams.crewScheduleBlockId,
            	comment : null,
            	deadLine : "24:00"
            }
        };

        vm.activateReport = function () {
        	MissingSignInService.activateReport(vm.model.activationData,
                  function (response) {
                     if (response.success) {
	                    	$uibModalInstance.close();
	                        MessageService.success(MessageService.MESSAGES.CREWING.SUCCESS_SAVE_MESSAGE);
	                		EventManagerService.notifyEventListeners(EventManagerService.EVENT.MISSIN_SIGN_IN.RELOAD_SIGN_OUT_DATA);
                        }
                    },
                    function (error) {
                        MessageService.error(error);
                    }
                )
         };

        vm.closeMe = function () {
            $uibModalInstance.close();
        };
    }
}());
